/*********
 * TipFields handles and populates data to the Tip HTML elements
 */

(function($){
    $.TipFields = function(options) {
        this._element = options.element || {};
        this._overlay_data = options.overlay_data || {};
        
        this._field_types = {
            TEXT: "text",
            IMAGE: "image",
            LINK: "link"
        };

        // functions that populate elements for each field type
        // e.g. TEXT modifies innerText and adds langkey, IMAGE modifies the SRC of an image
        this._field_handlers = {}; 
        this._add_basic_handlers();

        // get overlay_data from data-tip-<type>-* attributes
        this._data_attr_regexp = /(data-tip)-([\w]+)-(.+)/;
        if (this._element) {
            this._populate_data_from_element_attributes();
        }
    }; 

    function _sanitize_field_name(field_name) {
        return field_name.replace("-","_");
    }

    $.TipFields.prototype = { 

        _populate_data_from_element_attributes: function() { 
            var element_attributes = this._element.getAttributeNames();
            for (var i = 0; i < element_attributes.length;i++) {
                var attr = element_attributes[i];
                var matches = this._data_attr_regexp.exec(attr);

                if (matches && matches.length == 4) { 
                    var type = matches[2];
                    var field_name = _sanitize_field_name(matches[3]);

                    // add field if it does not exists
                    var field_list = this._get_field_list(type);
                    if (field_list.indexOf(field_name) < 0) {
                        field_list.push(field_name);
                    }
 
                    this._overlay_data[field_name] = this._element.getAttribute(attr);
                }
            } 
        },

        populate: function(tip_element) {
            // for each field type
            for(var type_key in this._field_types) {
                var type = this._field_types[type_key];
                var handler = this._field_handlers[type] || null;

                // if handler exist
                if (handler) {
                    // get the field map of current type
                    var field_list = this._get_field_list(type);

                    // for each of the registered fields in field_list
                    for (var i = 0; i < field_list.length;i++) {
                        var field_name = field_list[i];
                        var datum = this._overlay_data[field_name];
                        var child_selector = '.' + this._get_prefix(type) + '-' + field_name;
                        
                        var children = tip_element.querySelectorAll(child_selector);
                        for (var child_index = 0; child_index < children.length; child_index++) {
                            var child_element = children[child_index];
                            handler(child_element, datum);
                        } 
                    }
                }
            }
        },

        get_data: function() {
            var data = {};
            for(var type in this._field_types) {
                Object.assign(data, this._get_type_data(type));
            }

            return data;
        },

        _text_handler: function(element, datum) {
            element.innerText = datum;
            element.dataset.langkey = datum;
        },

        _img_handler: function(element, datum) {
            element.src = datum;
        },

        _link_handler: function(element, datum) {
            element.href = datum;
        },

        _add_basic_handlers: function(){
            this._add_field_handler(this._field_types.TEXT, this._text_handler.bind(this));
            this._add_field_handler(this._field_types.IMAGE, this._img_handler.bind(this));
            this._add_field_handler(this._field_types.LINK, this._link_handler.bind(this));
        },

        _add_field_handler: function(type, func) {
            var type_key = type.toUpperCase();
            // add field type if not listed in types
            if (!(type_key in this._field_types)) {
                this._field_types[type_key] = type.toLowerCase();
            }

            this._field_handlers[type] = func;
        },
        
        _get_type_data: function(type) {
            var map = this._get_field_list(type);
            var data = {};

            for(var property in map) {
                var field_name = map[property]; 
                data[this._get_prefix(type) + this._first_ucase(field_name)] = this._overlay_data[field_name];
            }

            return data;
        },

        _get_prefix: function(type) {
            return 'tip-' + type;
        },

        _get_field_list: function(type) { 
            var list_name = type + '_fields';
            if (typeof(this._overlay_data[list_name]) === "undefined") {
                this._overlay_data[list_name] = [];
            }

            return this._overlay_data[list_name];
        },
    }; 
})(ABDOMap);
